import React from 'react';
import { Grid, Typography } from '@mui/material';
import { ChainSvg as EmptyStateImg } from '../../../assets';
import {
    METADATA_SEARCH,
    metadataSearchStyles,
} from '../metadata-search-helpert';
import { CustomSearchField } from '@biq/apex-ui';
import {
    DefaultViewProps,
    METADATA_SEARCH_TERMS_LIMIT,
    metadataResultStyles,
} from './metadata-components.helper';

export const InitialMetadataView = ({
    onTermsChanged,
    onSubmit,
    fieldValue,
}: DefaultViewProps): React.JSX.Element => {
    return (
        <Grid sx={metadataSearchStyles.bodyContainer}>
            <Grid sx={metadataSearchStyles.contentContainer}>
                <Grid>
                    <img
                        style={metadataSearchStyles.emptyStateImage}
                        src={EmptyStateImg}
                        alt='Empty_State_Image'
                    />
                </Grid>
                <Grid sx={metadataSearchStyles.headingTextContainer}>
                    <Typography sx={metadataSearchStyles.termsHeadingText}>
                        {METADATA_SEARCH.IMAGE_HEADING_TEXT}
                    </Typography>
                </Grid>
                <Grid sx={metadataSearchStyles.subHeadingTextContainer}>
                    <Typography sx={metadataSearchStyles.termsSubheadingText}>
                        {METADATA_SEARCH.IMAGE_SUBHEADING_TEXT}
                    </Typography>
                </Grid>
                <Grid sx={metadataSearchStyles.searchFieldContainer}>
                    <CustomSearchField
                        customStyles={
                            metadataResultStyles.customSearchFieldStyles
                        }
                        fieldValue={fieldValue}
                        setFieldValue={onTermsChanged}
                        onButtonClick={onSubmit}
                        disabled={false}
                        isCaseSensitive={false}
                        tagLimit={METADATA_SEARCH_TERMS_LIMIT}
                    />
                </Grid>
            </Grid>
        </Grid>
    );
};
